"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendEmailDtoToJSON = exports.SendEmailDtoFromJSONTyped = exports.SendEmailDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
function SendEmailDtoFromJSON(json) {
    return SendEmailDtoFromJSONTyped(json, false);
}
exports.SendEmailDtoFromJSON = SendEmailDtoFromJSON;
function SendEmailDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'subject': !runtime_1.exists(json, 'subject') ? undefined : json['subject'],
        'body': !runtime_1.exists(json, 'body') ? undefined : json['body'],
    };
}
exports.SendEmailDtoFromJSONTyped = SendEmailDtoFromJSONTyped;
function SendEmailDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'subject': value.subject,
        'body': value.body,
    };
}
exports.SendEmailDtoToJSON = SendEmailDtoToJSON;
